import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useRequiredChartPlugins } from '../plugins/usePlugins.js';
import { ChartContainer } from '../styled.js';
const DoughnutChart = React.forwardRef(function DoughnutChart(props, ref) {
    const { 'data-testid': testId, resizeable, ...chartProps } = props;
    useRequiredChartPlugins(chartProps.options);
    return (_jsx(ChartContainer, { "data-testid": testId, $resizeable: resizeable, style: {
            height: chartProps.height ? `${chartProps.height}px` : undefined,
            width: chartProps.width ? `${chartProps.width}px` : undefined,
        }, children: _jsx(Doughnut, { ref: ref, ...chartProps }) }));
});
export default DoughnutChart;
